//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObjectCollection.js";
import "../no/BasePart.js";
let d=[[],[[["chaining_tolerance","distance_tolerance","angle_tolerance"],"CreateSection",{R_:{section:"Section"}},3,0],[[],"CreateSectionUsingDefaultTolerance",{R_:{section:"Section"}},0,0],[["curves","loop_option","chaining_tolerance","distance_tolerance","angle_tolerance","num_sections","section"],"CreateSectionsUsingCurves",{},5,0],[["curve"],"CreateSectionUsingSingleCurve",{R_:{sectionTag:"Section"}},1,0]],[]];
SPLM.SectionCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.SectionCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

SPLM.SectionCollection.LoopOption = Object.freeze({
    "Separate" : "Separate", "SeparateOuter" : "SeparateOuter"});

export default SPLM;